import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { DataGrid, Button } from 'devextreme-react';
import {
  Column,
  MasterDetail,
  Pager,
  Paging,
  RemoteOperations,
  Export,
} from 'devextreme-react/ui/data-grid';
import LoadingGif from '../../../../../images/animacion2[18].gif';

// doGetExcelSiniestros,
import { doGetSiniestrosEmpresa, setSiniestrosEmpresaFiltros } from './actions';
import { filterType, filterData } from '../../../../../helpers/filterHelper';
import TableFilter from '../../../../Shared/tableFilter.jsx';
import { formatDateForFilter } from '../../../../../helpers/dateFormat';
import UserInfoColumn from '../../../../Shared/UserInfoColumn';

import SiniestroInfoColumn from '../../../../Shared/SiniestroInfoColumn';

import validaciones from '../../../../../helpers/validaciones';
import moment from 'moment';

import { push } from 'connected-react-router';
import { checkAccess, ids, realCheckAccess } from '../../../../../helpers/rolAccess';
import { paths } from '../../../../../config/routes';

const Field = React.memo((props) => (
  <div
    className='row zero empresa-siniestro-detalle'
    style={props.IsHidden ? { display: 'none' } : {}}
  >
    <div className='col-5 empresa-siniestro-name' title={props.name ? props.name : '-'}>
      {props.name ? props.name : '-'}:
    </div>
    <div className='col-7 empresa-siniestro-valor' title={props.value ? props.value : '-'}>
      {props.value ? props.value : '-'}
    </div>
  </div>
));

const MasterDetailsComp = React.memo((props) => (
  <div className='row zero'>
    <div className='col-md-6 col-lg-6'>
      <Field name='Sucursal' value={props.data.Sucursal.Direccion} />
      <Field name='Cobertura' value={props.data.Cobertura.DescripcionCobertura} />
      <Field name='Cantidad de reposos' value={props.data.CantidadReposo} />
      <Field
        name='Mecanismo del accidente'
        IsHidden={props.data.TipoSiniestro.DescripcionTipoSiniestro === 'Enfermedad Profesional'}
        value={props.data.MecanismoAccidente}
      />
    </div>
    <div className='col-md-6 col-lg-6'>
      <Field name='Días totales del siniestro' value={props.data.DiasTotalesReposo} />
      <Field name='Días totales imputables' value={props.data.DiasTotalesImputables} />
      <Field name='Rebajas' value={props.data.DiasTotalesRebaja} />
    </div>
    <div className='col-12 siniestro-detail-table-button'>
      <Button type='default' onClick={() => props.handleViewDocuments(props)} text='Documentos' />
      <Button
        type='success'
        text='Ver detalle'
        style={{ marginLeft: 10 }}
        onClick={() => props.handleViewDetails(props)}
      />
    </div>
  </div>
));

class TablaSiniestros extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filtersLoaded: false,
      doFilterFechaPresentacion: false,
      FechaPresentacionInicio: null,

      doFilterFechaSiniestro: false,
      FechaSiniestro: null,
    };
    this.filterscutom = null;
    this.tableRef = React.createRef();
  }

  componentDidMount = async () => {
    if (!this.state.filtersLoaded) {
      // From: 1 año hacia atras
      // to: año actual.
      const data = {
        from: formatDateForFilter(moment().subtract(1, 'year')),
        to: formatDateForFilter(moment()),
      };

      this.setState({
        filtersLoaded: true,
        FechaPresentacionInicio: formatDateForFilter(moment().subtract(1, 'year')),
      });
      this.doGetSinestro(data, null);
    }
  };

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.sucursalId !== this.props.sucursalId ||
      prevProps.companyId !== this.props.companyId
    ) {
      const data = {
        // From: 1 año hacia atras
        // to: año actual.
        from: formatDateForFilter(moment().subtract(1, 'year')),
        to: formatDateForFilter(moment()),
      };
      this.setState({
        FechaPresentacionInicio: formatDateForFilter(moment().subtract(1, 'year')),
      });
      if (checkAccess(ids.siniestroEmpresa, this.props.userAccessIds)) {
        this.doGetSinestro(data, null);
      }
    }
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root));
    }
  };

  onExporting = (e) => {
    e.component.beginUpdate();
    e.component.columnOption('RutTrabajador', 'visible', true);
    e.component.columnOption('IdSiniestro', 'visible', true);
  };
  onExported = (e) => {
    e.component.columnOption('RutTrabajador', 'visible', false);
    e.component.columnOption('IdSiniestro', 'visible', false);
    e.component.endUpdate();
  };

  handleRowClick = (e) => {
    if (e.handled) {
      if (e.isExpanded) {
        e.component.collapseAll(-1);
        e.component.expandRow(e.key);
      } else {
        e.component.collapseRow(e.key);
      }
    } else if (!e.isExpanded) {
      e.component.collapseAll(-1);
      e.component.expandRow(e.key);
    } else {
      e.component.collapseRow(e.key);
    }
  };

  doGetSinestro = (data, filters) => {
    const filtros = {
      RutEmpresa: this.props.companyId,
      Pagina: 1,
      RegistrosPorPagina: 100000,
      FechaPresentacionInicio: data.from,
      FechaPresentacionFin: data.to,
    };
    if (!validaciones.isEmpty(filters)) {
      filtros.FechaSiniestroInicio = filters.from;
      filtros.FechaSiniestroFin = filters.to;
    }
    if (validaciones.emptyText(this.props.sucursalId)) {
      filtros.idSucursal = this.props.sucursalId;
    }
    this.props.dispatch(doGetSiniestrosEmpresa(filtros));
  };

  handleFilterChange = (text, filters) => {
    if (filters) {
      filters.forEach((element) => {
        if (element.column === 'TipoSiniestro') {
          element.filterValue = 'DescripcionTipoSiniestro';
          element.value.value = element.value.text;
        }
        if (element.column === 'PrestacionEconomica' || element.column === 'ReposoActivo') {
          element.type = 'bool';
        }
      });
    }

    const currentFilters = [...filters];

    if (text) {
      currentFilters.push({
        column: 'RutTrabajador',
        filterValue: null,
        value: { text, value: text },
        type: filterType.search,
      });
      currentFilters.push({
        column: 'NombreTrabajador',
        filterValue: null,
        value: { text, value: text },
        type: filterType.search,
      });
    }

    const FechaPresentacion =
      currentFilters.length > 0
        ? currentFilters.filter((f) => f.column === 'FechaPresentacion')
        : [];
    if (FechaPresentacion.length > 0) {
      const pivotFecha = FechaPresentacion.find((i) => i.column === 'FechaPresentacion');
      let FechaDesde = null;
      if (this.state.doFilterFechaPresentacion === true) {
        FechaDesde = this.state.FechaPresentacionInicio;
      } else {
        FechaDesde = formatDateForFilter(moment().subtract(1, 'year'));
      }
      const dateIsBefore = moment(pivotFecha.value.value.from).isBefore(moment(FechaDesde));

      // llamado al api cuando las fechas son menores con respecto a las que mande en el rango y guardo esa fecha desde
      if (dateIsBefore === true) {
        const data = {
          from: formatDateForFilter(moment(pivotFecha.value.value.from)),
          to: formatDateForFilter(moment(pivotFecha.value.value.to)),
        };
        this.doGetSinestro(data, null);
        this.setState({
          doFilterFechaPresentacion: true,
          FechaPresentacionInicio: pivotFecha.value.value.from,
        });
      }
    }
    const FechaSiniestro =
      currentFilters.length > 0 ? currentFilters.filter((f) => f.column === 'FechaSiniestro') : [];
    if (FechaSiniestro.length > 0) {
      const pivotFecha = FechaSiniestro.find((i) => i.column === 'FechaSiniestro');
      let FechaDesde = null;

      if (this.state.doFilterFechaSiniestro === true) {
        FechaDesde = this.state.FechaSiniestro;
      } else {
        FechaDesde = formatDateForFilter(moment().subtract(1, 'year'));
      }
      const dateIsBefore = moment(pivotFecha.value.value.from).isBefore(moment(FechaDesde));

      // llamado al api cuando las fechas son menores con respecto a las que mande en el rango y guardo esa fecha desde
      if (dateIsBefore === true) {
        const data = {
          from: formatDateForFilter(moment(pivotFecha.value.value.from)),
          to: formatDateForFilter(moment(pivotFecha.value.value.to)),
        };
        const filtros = {
          from: formatDateForFilter(moment(pivotFecha.value.value.from)),
          to: formatDateForFilter(moment(pivotFecha.value.value.to)),
        };

        this.doGetSinestro(data, filtros);
        this.setState({
          doFilterFechaSiniestro: true,
          FechaSiniestro: pivotFecha.value.value.from,
        });
      }
    }

    if (
      (this.state.doFilterFechaPresentacion && FechaPresentacion.length === 0) ||
      (this.state.doFilterFechaSiniestro && FechaSiniestro.length === 0)
    ) {
      // vuelvo a la carga de datos inicial. al limpiar el rango de fecha que fue menor a la orginal
      const data = {
        from: formatDateForFilter(moment().subtract(1, 'year')),
        to: formatDateForFilter(moment()),
      };
      this.doGetSinestro(data);
      this.setState({
        doFilterFechaPresentacion: false,
        FechaPresentacionInicio: null,
        doFilterFechaSiniestro: false,
        FechaSiniestro: null,
      });
    }

    const newData = filterData(this.props.siniestros, currentFilters);

    if (currentFilters.length > 0) {
      this.props.dispatch(setSiniestrosEmpresaFiltros(newData));
    } else {
      this.props.dispatch(setSiniestrosEmpresaFiltros(this.props.siniestros));
    }
  };

  pivotDownloadExcel = () => {
    this.tableRef.exportToExcel(false);
    this.props.postTagManager(
      { label: 'Clic Btn: Siniestros empresa - Descarga excel', response: 'Éxito' },
      this.props.dispatch,
    );
  };

  downloadExcel = (options) => {
    if (options.gridCell.rowType === 'data') {
      options.horizontalAlignment = 'left';
    }
  };

  render() {
    return (
      <div className='table-wrapper'>
        <TableFilter
          placeholder='Buscar trabajador por nombre o rut'
          onChange={this.handleFilterChange}
          filters={this.props.filtrosSiniestros}
          show={true}
          buttons={{
            filter: { buttonName: 'iconFilter', visible: true, buttonAction: null },
            document: { buttonName: 'iconDocument', visible: false, buttonAction: null },
            download: {
              buttonName: 'iconDownload',
              visible: true,
              buttonAction: this.pivotDownloadExcel,
              active: !!this.props.isDownloadLoading,
            },
            newItem: { buttonName: 'custom', visible: false, buttonAction: null },
          }}
        />
        <DataGrid
          id='SiniestroDataGrid'
          dataSource={this.props.siniestrosWithFilter}
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          className='custom-table empresas'
          ref={(ref) => {
            if (ref !== null) this.tableRef = ref.instance;
          }}
          noDataText=''
          rowAlternationEnabled
          hoverStateEnabled
          loadPanel={{
            enabled: true,
            showPane: true,
            showIndicator: true,
            indicatorSrc: LoadingGif,
            text: 'Cargando...',
          }}
          onContentReady={(e) => {
            if (e.component.totalCount() === 0 || this.props.totalSiniestros === 0) {
              const config = {};
              config.addClass = 'table-margin';
              const noDataSpan = e.component.element().querySelector('.dx-datagrid-nodata');
              const element = validaciones.noDataDOMElement(config, 'Sin siniestros');
              noDataSpan.appendChild(element);
            }
          }}
          onRowClick={this.handleRowClick}
          selection={{
            mode: 'single',
          }}
          onExporting={this.onExporting}
          onExported={this.onExported}
        >
          <MasterDetail
            enabled
            component={(props) => (
              <MasterDetailsComp
                handleViewDocuments={this.props.handleViewDocuments}
                handleViewDetails={this.props.handleViewDetails}
                {...props}
              />
            )}
          />

          <Column
            allowSearch
            caption='Trabajador'
            calculateCellValue={(rowData) => `${rowData.NombreTrabajador}`}
            cellTemplate={(element, row) => (
              <React.Fragment>
                {ReactDOM.render(
                  <UserInfoColumn
                    nombre={row.data.NombreTrabajador}
                    rut={row.data.RutTrabajador}
                  />,
                  element,
                )}
              </React.Fragment>
            )}
          />
          <Column caption='Rut' dataField='RutTrabajador' visible={false} />

          <Column
            caption='Siniestro'
            calculateCellValue={(rowData) => `${rowData.TipoSiniestro.DescripcionTipoSiniestro}`}
            cellTemplate={(element, row) => (
              <React.Fragment>
                {ReactDOM.render(
                  <SiniestroInfoColumn
                    active={row.data.ReposoActivo}
                    title={row.data.TipoSiniestro.DescripcionTipoSiniestro}
                    subtitle={Number(row.data.IdSiniestro).toString()}
                  />,
                  element,
                )}
              </React.Fragment>
            )}
            dataType='object'
          />
          <Column caption='Id Siniestro' dataField='IdSiniestro' visible={false} />

          <Column
            caption='Fecha siniestro'
            dataField='FechaSiniestro'
            calculateCellValue={(rowData) =>
              `${
                rowData.FechaSiniestro ? moment(rowData.FechaSiniestro).format('DD/MM/YYYY') : 'S/D'
              }`
            }
            dataType='date'
            // sortIndex={0}
            // sortOrder="asc"
            sortingMethod={(v1, v2) => {
              const v1d = moment(v1, 'DD/MM/YYYY');
              const v2d = moment(v2, 'DD/MM/YYYY');
              if (v1d.isAfter(v2d)) return -1;
              if (v1d.isSame(v2d)) return 0;
              if (v1d.isBefore(v2d)) return 1;
              return 0;
            }}
            format='dd/MM/yyyy'
          />

          <Column
            caption='Fecha presentación'
            dataField='FechaPresentacion'
            calculateCellValue={(rowData) =>
              `${
                rowData.FechaPresentacion
                  ? moment(rowData.FechaPresentacion).format('DD/MM/YYYY')
                  : 'S/D'
              }`
            }
            format='dd/MM/yyyy'
            dataType='date'
            sortIndex={0}
            sortOrder='asc'
            sortingMethod={(v1, v2) => {
              const v1d = moment(v1, 'DD/MM/YYYY');
              const v2d = moment(v2, 'DD/MM/YYYY');
              if (v1d.isAfter(v2d)) return -1;
              if (v1d.isSame(v2d)) return 0;
              if (v1d.isBefore(v2d)) return 1;
              return 0;
            }}
          />

          <Column
            // dataField="PrestacionEconomica"
            caption='Prestaciones económicas'
            allowFiltering
            calculateCellValue={(rowData) =>
              `${rowData.PrestacionEconomica === true ? 'si' : 'no'}`
            }
            cellTemplate={(element, row) => (
              <React.Fragment>
                {ReactDOM.render(
                  <i
                    className={`achs-icon siniestros-empresa ${
                      row.data.PrestacionEconomica ? 'active' : ''
                    }`}
                  >
                    {row.data.PrestacionEconomica ? 'c' : 'd'}
                  </i>,
                  element,
                )}
              </React.Fragment>
            )}
          />

          <Pager
            visible
            showInfo
            infoText={(page, total, items) => `Página ${page} de ${total} (${items} resultados)`}
          />

          <Paging pageSize={10} />

          {/*<RemoteOperations*/}
          {/*  paging={false}*/}
          {/*  filtering*/}
          {/*  summary={false}*/}
          {/*  groupPaging={false}*/}
          {/*  grouping={false}*/}
          {/*  sorting={false}*/}
          {/*/>*/}
          {/*<Export visible={false} enabled customizeExcelCell={this.downloadExcel} allowExportSelectedData={false} texts fileName="siniestrosEmpresa" />*/}
        </DataGrid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  siniestros: state.siniestroEmpresa.siniestros,
  siniestrosWithFilter: state.siniestroEmpresa.siniestrosWithFilter,
  filtrosSiniestros: state.siniestroEmpresa.filtrosSiniestros,
  companyId: state.global.companyId,
  totalSiniestros: state.siniestroEmpresa.totalSiniestros,
  sucursalId: state.global.sucursalId,
  isDownloadLoading: state.siniestroEmpresa.isDownloadLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TablaSiniestros);
